import {AppFunction} from "../misc/types";
import View from "../framework/view";
import {AccountView} from "../views/account";

export class AccountFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new AccountView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/account`;
    }

}
